import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import * as moment from 'moment';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';
import {Daytime, QuestionTime} from '../model/model';

// hours for expectedAt
const MORNING_TIME: number = 0;
const MIDDAY_TIME: number = 12;
const EVENING_TIME: number = 18;
const RESILIENCE_TIME: number = 19;
const NIGHT_TIME: number = 20;

@Injectable()
export class DaytimeRepository {

  private requestOptions = {ResponseType: 'response', withCredentials: true};

  constructor(
    private _http: HttpClient,
    private _authRequest: AuthRequest,
  ) { }

  public getDaytime(): Observable<Daytime> {
    const daytime: Daytime = this._getDaytime(new Date());
    return of(daytime);
  }

  public getQuestionTimeByLastAnswerDate(lastAnswerDate: Date): Observable<QuestionTime> {
    // the lastAnswerDate was made from a UTC what is meant to be also the local time (18:00 from server shall be 18:00 at user);
    // but it is mapped to e.g. 20:00 GMT+0200, so we have to correct this time, because _getDaytime() uses local time
    const lastAnswerDateAsLocal: Date = new Date(lastAnswerDate.getTime() + lastAnswerDate.getTimezoneOffset() * 60 * 1000);

    const lastQuestionTime: QuestionTime = {
      date: lastAnswerDate,  // <= here we use intentionally the "orioginal utc" value
      daytime: this._getDaytime(lastAnswerDateAsLocal),
    };

    return this.getNextQuestionTime(lastQuestionTime);
  }

  public getNextQuestionTime(lastQuestionTime: QuestionTime): Observable<QuestionTime> {
    const data: {} = {
      lastQuestionTime: lastQuestionTime,
    };
    return this._authRequest.handleRequest(
      this._http.post(environment.reflection.nextQuestionTimeRoute, data, this.requestOptions),
    ).pipe(map((response) => <QuestionTime> response));
  }

  public getCurrentQuestionTime(): Observable<QuestionTime> {
    return this._authRequest.handleRequest(
      this._http.get(environment.reflection.currentQuestionTimeRoute, this.requestOptions),
    ).pipe(map((response) => <QuestionTime> response));
  }

  private _getDaytime(date: Date): Daytime {

    const startOfMorning: moment.Moment = moment(date).startOf('day').add(MORNING_TIME, 'hours');
    const startOfMidday: moment.Moment = moment(date).startOf('day').add(MIDDAY_TIME, 'hours');
    const startOfEvening: moment.Moment = moment(date).startOf('day').add(EVENING_TIME, 'hours');
    const startOfResilience: moment.Moment = moment(date).startOf('day').add(RESILIENCE_TIME, 'hours');
    const startOfNight: moment.Moment = moment(date).startOf('day').add(NIGHT_TIME, 'hours');

    const dateHasBeenProvided: boolean = date !== undefined;
    const target: moment.Moment = dateHasBeenProvided
      ? moment(date)
      : moment();

    if (target.isBetween(startOfMorning, startOfMidday, 'minutes', '[)')) {
      return Daytime.Morning;
    }
    if (target.isBetween(startOfMidday, startOfEvening, 'minutes', '[)')) {
      return Daytime.Midday;
    }
    if (target.isBetween(startOfEvening, startOfResilience, 'minutes', '[)')) {
      return Daytime.Evening;
    }
    if (target.isBetween(startOfResilience, startOfNight, 'minutes', '[)')) {
      return Daytime.Resilience;
    }

    return Daytime.Night;
  }

}
